import { HorizontalToggle } from '@hc/component-lib/hclib/components/atoms/horizontal-toggle';

import {
  PROPERTY_DETAILS_TYPE_GENERAL,
  PROPERTY_DETAILS_TYPE_SOURCES,
  TIMELINE_SUBJECT_DETAILS_MISSING_MSG
} from 'legacy/appstore/constants';

import ConditionSelectorContainer from 'legacy/containers/condition-selector';
import PropertyDetailsGeneralContainer from 'legacy/containers/property-details-general';
import PropertyDetailsSourcesContainer from 'legacy/containers/property-details-sources';
import ValueAdjustmentContainer from 'legacy/containers/value-adjustment';
import { EffectiveDateWarning } from 'legacy/containers/effective-date-warning';

import PropertyExplorerSection from 'legacy/components/PropertyExplorerSection';
import PropertyExplorerSectionHeading from 'legacy/components/PropertyExplorerSectionHeading';
import Tooltip from 'legacy/components/generic/Tooltip';
import TooltipDefaultTrigger from 'legacy/components/generic/TooltipDefaultTrigger';

import { PropertyDetailsSection as theme } from 'legacy/css-modules';

const PropertyDetailsSection = ({
  isEffectiveDateReport,
  timelineSubjectDetailsMissing,
  addressId,
  title,
  tooltipCopy,
  visiblePropertyDetailsType,
  onChangeVisiblePropertyDetails
}) => {
  return (
    <PropertyExplorerSection
      className={theme.PropertyDetailsSection}
      dataHcName="property-details-section"
    >
      <PropertyExplorerSectionHeading
        className={theme.Heading}
        dataHcName="property-details-header"
      >
        <div>
          {title}
          {!isEffectiveDateReport && (
            <Tooltip
              trigger={
                <TooltipDefaultTrigger dataHcName="property-details-info-button" />
              }
              content={tooltipCopy.split('\n').map((l, i) => (
                <p key={`tooltipLine-${i}`}>{l}</p>
              ))}
              transparentScreen
            />
          )}
          {isEffectiveDateReport && timelineSubjectDetailsMissing && (
            <Tooltip
              trigger={
                <EffectiveDateWarning
                  className={theme.EffectiveDateWarning}
                  dataHcName="subject-details-today-warning"
                  today
                />
              }
              content={TIMELINE_SUBJECT_DETAILS_MISSING_MSG}
              transparentScreen
            />
          )}
        </div>
        {!isEffectiveDateReport && (
          <HorizontalToggle
            className={theme.Toggle}
            onSelect={onChangeVisiblePropertyDetails}
            value={visiblePropertyDetailsType}
            theme={theme}
            dataHcName="property-details-toggle"
            style={{ lineHeight: '10px', fontSize: '12px', marginLeft: '20px' }}
            options={[
              {
                label: 'General Details',
                value: PROPERTY_DETAILS_TYPE_GENERAL
              },
              { label: 'Data Sources', value: PROPERTY_DETAILS_TYPE_SOURCES }
            ]}
          />
        )}
      </PropertyExplorerSectionHeading>
      {visiblePropertyDetailsType === PROPERTY_DETAILS_TYPE_GENERAL ? (
        <PropertyDetailsGeneralContainer addressId={addressId} />
      ) : (
        <PropertyDetailsSourcesContainer addressId={addressId} />
      )}
      {!isEffectiveDateReport && (
        <div className={theme.BelowDetails}>
          <div className={theme.ConditionSection}>
            <h3
              className={theme.ConditionHeader}
              data-hc-name="condition-header"
            >
              Adjust Home Condition
            </h3>
            <ConditionSelectorContainer />
          </div>

          <div
            data-hc-name="property-details-adjustment-section"
            className={theme.AdjustmentSection}
          >
            <ValueAdjustmentContainer />
          </div>
        </div>
      )}
    </PropertyExplorerSection>
  );
};

export default PropertyDetailsSection;
